const API_LOGIN_URL = process.env.REACT_APP_LOGIN_URL;

const TEST_USER = {
    email: process.env.REACT_APP_TEST_USER_EMAIL,
    password: process.env.REACT_APP_TEST_USER_PASSWORD,
};

export { API_LOGIN_URL, TEST_USER };
